import type { Ticket } from '~/features/workflows-clm-evolution/types';
import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import { GetTicketApiResponse } from '../../types/k2/tickets';

type Request = {
  ticketId: string;
};
type ServerResponse = GetTicketApiResponse;

export const getTicketK2 = async (
  request: Request,
  options: ServiceRequestConfig = {},
): Promise<Ticket> => {
  const serverResponse: ServerResponse = await k2.get(
    `/tickets/${request.ticketId}`,
    { showErrorToast: true, ...options },
  );

  return mapResponse(serverResponse);
};

const mapResponse = (serverResponse: ServerResponse): Ticket => {
  return {
    ...serverResponse.data.attributes,
    id: serverResponse.data.id,
  };
};
